import APIOfferServices from "@/api/modules/offer-services";

const state = () => ({
  servicesList: [],
  service: null,
});

export default {
  namespaced: true,
  state,
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    getServices({ commit }, params) {
      return APIOfferServices.getServices(params).then((response) => {
        if (response && response.data) {
          const list = response.data.services || response.data || [];
          commit("SET_DATA", { type: "servicesList", data: Array.isArray(list) ? list : [] });
        }
      });
    },
    upsertService(_, data) {
      return APIOfferServices.upsertService(data);
    },
    deleteService(_, id) {
      return APIOfferServices.deleteService(id);
    },
  },
};
